export class MetricService {
	static setCustomMetric(metric) {
		if (window && window['elkRUM'] && window['elkRUM'].setCustom) {
			window['elkRUM'].setCustom(`FIT_PICKUP_${metric}`, {});
		}
	}

	static setNotifyMetric(type, details, located, placement, otherSelected) {
		if (window && window['elkRUM'] && window['elkRUM'].setCustom) {
			window['elkRUM'].setCustom('FIT_PICKUP_NOTIFY',{'type':type, 'details':details, 'located':located, 'placement':placement, 'otherSelected':otherSelected})
		}
	}
}
